import { ReactComponent as BurgerIcon } from "../../../../assets/icons/burger.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close-alt.svg";
import { ReactComponent as CogIcon } from "../../../../assets/icons/cog.svg";
import { ReactComponent as FullScreenIcon } from "../../../../assets/icons/fullscreen.svg";
import { ReactComponent as MoonIcon } from "../../../../assets/icons/moon.svg";
import { ReactComponent as SmallScreenIcon } from "../../../../assets/icons/smallscreen.svg";
import { ReactComponent as SunIcon } from "../../../../assets/icons/sun.svg";
import "./header.meta.scss";
//import Modal, {IModalBtns, IModalFooterBtns} from "../../../ui/modal/Modal";
import { observer } from "@legendapp/state/react";
import { useState } from "react";
import { IUserDarkMode, state$ } from "../../../../state";
import Modal, { IModalBtns } from "../../../ui/modal/Modal";


export interface IHeaderMeta {
  requestToggleBurgerMenu: (state: boolean) => void,
  isMenuVisible: boolean
}

const HeaderMeta = observer(({ requestToggleBurgerMenu, isMenuVisible }: IHeaderMeta) => {
  const [isResetModalVisibility, setResetModalVisibility] = useState(false);

  const isFullWidthState = state$.settings.isFullWidthState.get();
  const darkModeState = state$.settings.darkMode.get();


  const resetActions = [{
    id: 1,
    title: 'Cancel',
    type: [IModalBtns.MUTE, IModalBtns.SHORT],
    actions: () => {
      setResetModalVisibility(false);
    },
  },
  {
    id: 2,
    title: 'Continue',
    type: [IModalBtns.DEFAULT, IModalBtns.SHORT],
    actions: () => {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        state$.settings.darkMode.set(IUserDarkMode.SYSTEM_SET);
      } else {
        state$.settings.darkMode.set(IUserDarkMode.NOT_SET);
      }

      state$.settings.isFullWidthState.set(false);
      setResetModalVisibility(false);
    }
  }]

  return (
    <div className="header-meta d-flex">
      <div className="header-actions d-flex">
        <button type="button"
          className={`btn--reset header-action d-flex header-action__settings header-action--burger ${isMenuVisible ? 'header-action--active' : ''} `}
          onClick={() => {
            requestToggleBurgerMenu(!isMenuVisible);
          }}>
          <span className="header-action__icon d-flex">
            <BurgerIcon className={`header-action__icon-animate ${!isMenuVisible ? 'header-action__icon-animate--visible' : ''}`} />

            <CloseIcon className={`header-action__icon-animate ${isMenuVisible ? 'header-action__icon-animate--visible' : ''}`} />
          </span>
        </button>

        <button type="button" className="btn--reset header-action d-flex header-action__toggle-modes" onClick={() => {
          if (darkModeState === IUserDarkMode.NOT_SET || darkModeState === IUserDarkMode.NOT_SET_USER) {
            return state$.settings.darkMode.set(IUserDarkMode.USER_SET);
          }
          return state$.settings.darkMode.set(IUserDarkMode.NOT_SET_USER);
        }}>

          <span className="header-action__icon d-flex">
            <MoonIcon className={`header-action__icon-animate ${darkModeState === IUserDarkMode.NOT_SET || darkModeState === IUserDarkMode.NOT_SET_USER ? 'header-action__icon-animate--visible' : ''}`} />

            <SunIcon className={`header-action__icon-animate ${darkModeState === IUserDarkMode.SYSTEM_SET || darkModeState === IUserDarkMode.USER_SET ? 'header-action__icon-animate--visible' : ''}`} />
          </span>
        </button>

        {/*<button type="button" className="btn--reset header-action d-flex header-action__help">*/}
        {/*  <span className="header-action__icon d-flex">*/}
        {/*    <QuestionIcon />*/}
        {/*  </span>*/}
        {/*</button>*/}

        <button type="button"
          className="btn--reset header-action d-flex header-action__settings"
          onClick={() => setResetModalVisibility(true)}>
          <span className="header-action__icon d-flex">
            <CogIcon />
          </span>
        </button>

        <button type="button"
          className="btn--reset header-action d-flex header-action__settings header-action--fs"
          onClick={() => {
            state$.settings.isFullWidthState.set(!isFullWidthState);
          }}>
          <span className="header-action__icon d-flex">
            <FullScreenIcon className={`header-action__icon-animate ${!isFullWidthState ? 'header-action__icon-animate--visible' : ''}`} />

            <SmallScreenIcon className={`header-action__icon-animate ${isFullWidthState ? 'header-action__icon-animate--visible' : ''}`} />
          </span>
        </button>

        <Modal title={'Confirmation'}
          toggleVisibility={isResetModalVisibility}
          footerBtns={resetActions}
          onToggle={setResetModalVisibility}>
          <p>
            The following application settings will be reset:
          </p>

          <div className="modal-reset-info">
            <ul className="list list--standard">
              <li>
                Dark mode will revert to system settings
              </li>

              <li>
                Full width view will reverse to contained view
              </li>
            </ul>
          </div>

          <p>
            Are you sure you want to continue?
          </p>
        </Modal>
      </div>
    </div>
  )
})

export default HeaderMeta;
